module.exports = __webpack_public_path__ + "img/pic3.6236c02d.jpg";